<div class="content content-with-elevation">
  <div #contactInfoView class="header-helper">{{title}}</div>
  <contact-info-view *ngIf="!editmode" [lastchange]="lastchange" [contactVO]="contactVO" (edit)="edit($event)" [change]="change" [pendingRequestChangeID]="pendingRequestChangeID"
                       [viewMode]="viewMode"></contact-info-view>
  <div #contactInfoEdit>
    <contact-info-edit *ngIf="editmode" [contactVO]="contactVO" (contactVOOutput)="contactOutPut($event)" (cancelOutPut)="cancel($event)"></contact-info-edit>
  </div>
</div>
